import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ParentComponentApi} from '../profile/profile.component';
import {DxFormComponent} from 'devextreme-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http'; 
import { Configuration } from '../../../app.constants';
import {HelperService} from '../../../shared/services/helper.service';
import { compilePipeFromMetadata } from '@angular/compiler';
import {StudentSportsDtlService,StudentSportsDetails, SportsDetails,LevelDetails} from '../../services/StudentSportsDtl.service';
import { ImageUploadService } from '../../../shared/services/image-upload.service';


@Component({
  selector: 'StudentSportsDtl',
  templateUrl: './StudentSportsDtl.component.html', 
  styleUrls: ['./StudentSportsDtl.component.scss']
})
export class StudentSportsDtlComponent implements OnInit {

  @ViewChild(DxFormComponent) StudentSportsDtlForm: DxFormComponent;
  StudentSportsDtlData:StudentSportsDetails;


  value: any[] = [];
  urlDoc: string;
  popupVisible: boolean;
  popupTitle: string;
  YearLbl: string;

  showButtons:boolean=false;
  loadIndicatorVisible:boolean=false;
  readOnly: boolean = false;
  documentId: string;
  
  isValid: boolean; 
  SaveBtnDisabled: boolean;
  DeleteBtnDisabled :boolean; 
  errorMessage: string[] = new Array(); 
  dataSource:any;  
  SportsData:any;  
  DocumentsList:any;
  SportsList:any;
  BasicLevelList:any
  LanguageLabel:any;
  PreStudentPhyInfoID:0;
  namePattern: any = /^[^0-9]+$/;
  Pattern1: any =/^[^<>]+$/;
  maxYear=0;
  BirthYear=0;
  constructor(private http:HttpClient,
    private router: Router,private route: ActivatedRoute, 
    private StudentSportsDtlService:StudentSportsDtlService, 
    private configuration: Configuration,private helperService:HelperService ) { 
      this.maxYear = (new Date()).getFullYear();
    }

  ngOnInit() {  
    this.LanguageLabel =this.configuration.LanguageLabel[0]; 


    this.getsportsDetails();
    this.getBasicLevel();
    this.getStuentsportsDetails();

    
    this.StudentSportsDtlData ={ 
      PreStudentSportsID:null, 
      StudentID:null, 
      AcademicInstanceID:null, 
      ExamInstanceID:null, 
      SpNmID:null, 
      LevelID:null, 
      SpName:null,
      LevelName:null,
      Year:null, 
      Description:null, 
      CertificateDoc:null, 
      DeleteFlag:null, 
      CreatedLoginID:null,  
      UpdatedLoginID:null,
    }
     
     
  }
  getsportsDetails() {   
    this.StudentSportsDtlService.GetBasicSportNamesByID(0) 
    .subscribe((data: SportsDetails[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => {  
        if(this.dataSource.length>0){
          this.SportsList=this.dataSource;  
        } 
      }); 
  }
  getBasicLevel() {   
    this.StudentSportsDtlService.GetBasicLevelListByID(0,'S') 
    .subscribe((data: LevelDetails[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { 
        if(this.dataSource.length>0){
          this.BasicLevelList=this.dataSource; 
        } 
      }); 
  }
  
  getStuentsportsDetails() {   
    this.DocumentsList=[];   
    this.StudentSportsDtlService.GetPreStudentSportsByStudentId(this.configuration.StudentID,0) 
    .subscribe((data: StudentSportsDetails[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger
        if(this.dataSource.length>0){ 
          this.DocumentsList=this.dataSource; 
        } 
      }); 
  }
  
  getdata() {  debugger
    this.getStuentsportsDetails();
  }

  
  saveRecord() {
    this.SaveBtnDisabled = true;
    if ((this.configuration.StudentID==null)||(this.configuration.StudentID==0))
    {
      this.helperService.showSuccessMessage("Blank Student Id Not Allowed.");
      this.SaveBtnDisabled = false;
      return false;    
    }
    if (this.StudentSportsDtlData.SpNmID == null || this.StudentSportsDtlData.SpNmID == 0 || this.StudentSportsDtlData.SpNmID == undefined) {
      this.helperService.showWarningMessage("Select Sports.")
      this.SaveBtnDisabled = false;
      return false;
    }
   /*  if (this.StudentSportsDtlData.LevelID == null || this.StudentSportsDtlData.LevelID == 0 || this.StudentSportsDtlData.LevelID == undefined) {
      this.helperService.showWarningMessage("Selet Level.")
      return false;
    }*/
    if (this.StudentSportsDtlData.Year == null || this.StudentSportsDtlData.Year == 0 || this.StudentSportsDtlData.Year == undefined) {
      this.helperService.showWarningMessage("Enter Year.")
      this.SaveBtnDisabled = false;
      return false;
    } 
    this.SaveBtnDisabled = true;

    
    this.StudentSportsDtlData.StudentID=this.configuration.StudentID;
    this.StudentSportsDtlData.CreatedLoginID = this.configuration.CreatedLoginID;
    this.StudentSportsDtlData.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.StudentSportsDtlData.AcademicInstanceID = this.configuration.AcademicInstanceID;
    this.StudentSportsDtlData.ExamInstanceID = this.configuration.ExamInstanceID;

    if (this.StudentSportsDtlData.PreStudentSportsID == null || this.StudentSportsDtlData.PreStudentSportsID == 0 || this.StudentSportsDtlData.PreStudentSportsID == undefined) {
      this.StudentSportsDtlData.PreStudentSportsID = 0;
    }


    if (this.StudentSportsDtlData.LevelID == null || this.StudentSportsDtlData.LevelID == 0 || this.StudentSportsDtlData.PreStudentSportsID == undefined) {
      this.StudentSportsDtlData.LevelID = 0;
    }

    var tempData :any=[];
    this.SportsData = {};
    this.SportsData.PreStudentSportsID   = this.StudentSportsDtlData.PreStudentSportsID  ;
    this.SportsData.StudentID            = this.StudentSportsDtlData.StudentID           ;
    this.SportsData.AcademicInstanceID   = this.StudentSportsDtlData.AcademicInstanceID  ;
    this.SportsData.ExamInstanceID       = this.StudentSportsDtlData.ExamInstanceID      ;
    this.SportsData.SpNmID               = this.StudentSportsDtlData.SpNmID              ;
    this.SportsData.LevelID              = this.StudentSportsDtlData.LevelID             ;
    this.SportsData.Year                 = this.StudentSportsDtlData.Year                ;
    this.SportsData.Description          = this.StudentSportsDtlData.Description         ;
    this.SportsData.CertificateDoc       = this.StudentSportsDtlData.CertificateDoc  ;
    this.SportsData.CreatedLoginID       = this.StudentSportsDtlData.CreatedLoginID;
    this.SportsData.UpdatedLoginID       = this.StudentSportsDtlData.UpdatedLoginID;
   
    
    this.isValid = this.StudentSportsDtlForm.instance.validate().isValid;
    if(this.isValid == true) {  
      this.errorMessage=[];
      debugger; 
      if(this.StudentSportsDtlData.PreStudentSportsID > 0 ){
        this.StudentSportsDtlData.StudentID=this.configuration.StudentID;
       this.StudentSportsDtlService.PostPreStudentSports(this.SportsData)
         .subscribe(value => {
           debugger
           if(value != null){             
              var value1:any=[];
              value1=value[0];
              if(value1.Id=='SpNmID'){
              this.SaveBtnDisabled = false;     
              this.helperService.showWarningMessage(value1.Message); 
              return false; 
              } 
              else{
              this.onSuccessSave();
              }
            }
            else{
            this.onSuccessSave();
            }
         },
           err => {
            this.SaveBtnDisabled = false;
             this.errorMessage=this.helperService.getErrorMessage(err);
             this.helperService.showSuccessMessage("Not Saved.");    
           },
           () => {
           
           });

      }
      else{
       this.StudentSportsDtlService.PostInsertPreStudentSports(this.SportsData)
         .subscribe(value => { 
          if(value != null){             
             var value1:any=[];
             value1=value[0];
             if(value1.Id=='SpNmID'){
             this.SaveBtnDisabled = false;     
             this.helperService.showWarningMessage(value1.Message); 
             return false; 
             } 
             else{
             this.onSuccessSave();
             }
           }
           else{
           this.onSuccessSave();
           }
         },
           err => {
            this.SaveBtnDisabled = false;
             this.errorMessage=this.helperService.getErrorMessage(err);
             this.helperService.showSuccessMessage("Not Saved.");    
           },
           () => {
           
           });

      }
    }
  }
  cancelClick(){
    this.SaveBtnDisabled = false;    
    this.DeleteBtnDisabled = false;
    this.errorMessage=[];
    this.router.navigate(['/login-form']);
  }

  clearData(){     
   }
   
   onSuccessSave() {         
     this.getStuentsportsDetails();
    this.StudentSportsDtlData.PreStudentSportsID  = 0;
     this.helperService.showSuccessMessage("Saved Successfully.");    
     this.StudentSportsDtlData.PreStudentSportsID   = 0;
     this.StudentSportsDtlData.StudentID            =this.configuration.StudentID;
     this.StudentSportsDtlData.AcademicInstanceID   = 0;
     this.StudentSportsDtlData.ExamInstanceID       = 0;
     this.StudentSportsDtlData.SpNmID               = 0;
     this.StudentSportsDtlData.LevelID              = 0;
     this.StudentSportsDtlData.Year                 =null;
     this.StudentSportsDtlData.Description          =null;
     this.StudentSportsDtlData.CertificateDoc       =null;
      this.DeleteBtnDisabled = true;
      this.SaveBtnDisabled = false;
   }
   
  deleteRecord() {
    this.StudentSportsDtlData.StudentID=this.configuration.StudentID;
    this.StudentSportsDtlData.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.StudentSportsDtlData.AcademicInstanceID = this.configuration.AcademicInstanceID;
    this.StudentSportsDtlData.ExamInstanceID = this.configuration.ExamInstanceID;
    
    this.SportsData = {};
    this.SportsData.PreStudentSportsID   = this.StudentSportsDtlData.PreStudentSportsID  ;
    this.SportsData.StudentID            = this.StudentSportsDtlData.StudentID           ;
    this.SportsData.AcademicInstanceID   = this.StudentSportsDtlData.AcademicInstanceID  ;
    this.SportsData.ExamInstanceID       = this.StudentSportsDtlData.ExamInstanceID      ; 
    this.SportsData.UpdatedLoginID       = this.StudentSportsDtlData.UpdatedLoginID;

   this.StudentSportsDtlService.PostDeletePreStudentSports(this.SportsData)
     .subscribe(value => {
      this.helperService.showSuccessMessage("Deleted Successfully."); 
      this.getStuentsportsDetails();
      this.StudentSportsDtlData.PreStudentSportsID   = 0;
      this.StudentSportsDtlData.StudentID            =this.configuration.StudentID;
      this.StudentSportsDtlData.AcademicInstanceID   = 0;
      this.StudentSportsDtlData.ExamInstanceID       = 0;
      this.StudentSportsDtlData.SpNmID               = 0;
      this.StudentSportsDtlData.LevelID              = 0;
      this.StudentSportsDtlData.Year                 =null;
      this.StudentSportsDtlData.Description          =null;
      this.StudentSportsDtlData.CertificateDoc       =null;
       this.DeleteBtnDisabled = true;
     },
       err => {
         this.errorMessage=this.helperService.getErrorMessage(err);
         this.helperService.showSuccessMessage("Not Deleted.");    
       },
       () => {
       
       });
  }
  viewPdfDocument(data) {
    debugger
    if (data.key.CertificateDoc.length > 0) {
      this.documentId = data.key.PreStudentSportsID;
      this.urlDoc = data.key.CertificateDoc ;
      this.openWindow();
    }
  }
  
  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.YearLbl = "" +  this.LanguageLabel.Year + "*";
    this.errorMessage = [];
    this.showInfo();
  }
  showInfo() {
    this.popupVisible = true;
  }
  popupHiding(e) {
    this.errorMessage = [];
  };


	EditClicked(e) {  debugger; 
    this.StudentSportsDtlData.PreStudentSportsID   = e.data.PreStudentSportsID;  
    this.StudentSportsDtlData.StudentID            =e.data.StudentID  ;
    this.StudentSportsDtlData.SpNmID               =e.data.SpNmID  ;
    this.StudentSportsDtlData.LevelID              =e.data.LevelID  ;
    this.StudentSportsDtlData.Year                 =e.data.Year ;
    this.StudentSportsDtlData.Description          =e.data.Description ;
    this.StudentSportsDtlData.CertificateDoc       =e.data.CertificateDoc ;
    if( e.data.PreStudentSportsID > 0)
      {             
        this.DeleteBtnDisabled = false;
      }
      else
      {             
        this.DeleteBtnDisabled = true;
      }
    }
    
  removeDocument(data) {
    if (data.key.CertificateDoc.length > 0) {
      var deleteDocument = {
        "PreStudentSportsID": data.key.PreStudentSportsID,
        "UpdatedLoginID": this.configuration.UpdatedLoginID,
        "StudentID": this.configuration.StudentID 
      }
     debugger;
      this.StudentSportsDtlService.PostRemovedSportsCertificate(deleteDocument)    
          .subscribe(value => {
           this.getdata();
           this.helperService.showSuccessMessage("File Deleted Successfully.");
        },
          error => {
            alert(error);
          },
          () => {
           
          });
    }
  }

}
